import { GzTableWebComponent } from './component/GzTableWebComponent';
import { WEB_COMPONENT_GZ_TABLE } from '../../webcomponents.constants';

export { GzTableWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TABLE, GzTableWebComponent);
